import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapMembersTabsComponent } from './bootstrap-members-tabs/bootstrap-members-tabs.component'


const routes: Routes = [
  {
    path: '', children: [
      {
        path: 'detail/association/:noc/:fedname', loadChildren: () => import('./continental-member-information/continental-member-information.module').then(m => m.ContinentalMemberInformationModule)
      },
      {
        path: ':noc', loadChildren: () => import('./members-information/members-information.module').then(m => m.MembersInformationModule)
      },
      {
        path: ':noc/:fedname', loadChildren: () => import('./members-information/members-information.module').then(m => m.MembersInformationModule)
      },
      { path: ':noc/:fedname/events', loadChildren: () => import('./members-events/members-events.module').then(m => m.MembersEventsModule) },
      { path: ':noc/:fedname/athletes', loadChildren: () => import('./members-athletes/members-athletes.module').then(m => m.MembersAthletesModule) },
      { path: ':noc/:fedname/news', loadChildren: () => import('./member-news/member-news.module').then(m => m.MemberNewsModule)}

    ], component: BootstrapMembersTabsComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DetailsPageRoutingModule { }
